__turbopack_context__.v({
  "actionButton": "XjMJKq_actionButton",
  "actionButtons": "XjMJKq_actionButtons",
  "anchor": "XjMJKq_anchor",
  "anchor--active": "XjMJKq_anchor--active" + " " + "XjMJKq_anchor",
  "baseListItem": "XjMJKq_baseListItem",
  "container": "XjMJKq_container",
  "container--open": "XjMJKq_container--open" + " " + "XjMJKq_container",
  "header": "XjMJKq_header",
  "list": "XjMJKq_list",
  "popularTilesContainer": "XjMJKq_popularTilesContainer",
});
